import { AppNS } from 'app';
import useInterval from 'app/core/hooks/useInterval';
import { generateCsvReport, getCsvReportState } from 'app/store/csv-reports';
import { RootState } from 'app/store/rootReducer';
import ButtonLoader from 'app/ui/components/button-loader/ButtonLoader';
import CsvDownloadIcon from 'app/ui/icons/CsvDownloadIcon';
import { ExternalButton } from 'app/ui_v2/components/external-button/ExternalButton';
import { useDispatch, useSelector } from 'react-redux';

import CachedIcon from '@mui/icons-material/Cached';
import { Box, Button } from '@mui/material';

export interface CsvButtonProps {
  queryParams: AppNS.Params;
}

export default function CsvButton(props: CsvButtonProps) {
  const { queryParams } = props;

  const { isActionLoading, currentCsvReportId, currentCsvReportUrl, delay } = useSelector(
    (state: RootState) => state.csvReports
  );

  const dispatch = useDispatch();

  useInterval(() => {
    if (currentCsvReportId) {
      dispatch(getCsvReportState(currentCsvReportId));
    }
  }, delay);

  const handleDownloadCsv = async () => {
    let params = {
      query: queryParams.search,
      search_by: queryParams.searchBy,
      date_from: queryParams.dateFrom,
      date_to: queryParams.dateTo,
      states: null as any,
      state: queryParams.state,
      agencyCompanyId: queryParams.agencyCompanyId,
      properties: { type: 'inspections_report' },
    };
    dispatch(generateCsvReport(params));
  };

  return (
    <>
      {currentCsvReportUrl && (
        <Button
          variant="outlined"
          disabled={isActionLoading}
          component={ExternalButton}
          to={currentCsvReportUrl}
          download
        >
          <CsvDownloadIcon />
          <Box ml={1}>Download CSV</Box>
        </Button>
      )}

      {!currentCsvReportUrl && (
        <Button
          variant="outlined"
          disabled={isActionLoading}
          onClick={() => {
            handleDownloadCsv();
          }}
        >
          <ButtonLoader isActive={isActionLoading} />
          {!isActionLoading && <CachedIcon />}
          <Box ml={1}>Generate CSV</Box>
        </Button>
      )}
    </>
  );
}
